import { Autocomplete, Box, Button, Drawer, Stack, TextField, Tooltip, Typography, FormControl, InputLabel, Select, MenuItem } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import '../reports.css';
import { ImagePaths } from '../../../../Utility/ImagePaths';
import CommonDatePicker from '../../../../Components/Common Components/CommonDatePicker';
import { CommonGridToolBarWithFilterText, CommonTimeRangePicker } from "../../../../Components/Common Components/CommonComponents";
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import { DateTime } from 'luxon';
import { formatDate, timeOnlyConvert } from '../../../../Components/CommonFunctions/CommonFunctions';

const genderList = [
    { label: "Male", value: "m" },
    { label: "Female", value: "f" },
    { label: "TransGender", value: "t" }
]
class DemographicsReport extends Component {

    constructor(props) {
        super(props)
        this.state = {
            page: 0,
            pageSize: 10,
            fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
            toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
            patientName: "",
            gender: [],
            appointmentDate: null,
            dateIndex: 1,
            patientData: [],
            FilteredFromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
            FilteredToDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
            FilterDatas: {
                "startTime":null,
                "endTime":null,
                "onError":false,
            },
            timeError: false,
            refTypeData: ["Source", "Doctor", "Staff"],
            refferedType: "",
            refSourceData: [],
            refStaffData: [],
            refferalValue: "",
        }
    }

    componentDidMount() {
        this.getPatientData()
        this.getReferralDoctorData()
        this.getRefSourceData()
        this.getStaffRefferalData()
    }

    errorMessage = (message) => {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: message
        })
    }

    onChangeHandler = (e) => {
        const { name, value } = e.target
        this.setState({
            [name]: value
        })
    }

    LoaderFunction = (key) => {
        this.setState({
            isLoader: key
        })
    }

    FilterDate = (from, to, index) => {
        this.setState({
            fromDate: from,
            toDate: to,
            dateIndex: index
        }, ()=> {
            this.state.FilterDatas.endTime = null
            this.setState({
                FilterDatas:this.state.FilterDatas
            })
        })
    }

    getPatientData = () => {
        try {
            this.LoaderFunction(true)
            let appointmentDate = this.state.appointmentDate === null ? "" : this.state.appointmentDate
            let genderSearch = [];
            this.state.gender.forEach(element => { genderSearch.push(element.value) });
            var {FilterDatas} = this.state
            let start_time = FilterDatas.startTime ? new Date(FilterDatas.startTime) : ''
            let end_time = FilterDatas.endTime ? new Date(FilterDatas.endTime) : ''
            let setStartTime = start_time === '' ? '' : DateTime.fromJSDate(start_time).toLocaleString(DateTime.TIME_24_WITH_SECONDS);
            let setEndTime = end_time === '' ? '' : DateTime.fromJSDate(end_time).toLocaleString(DateTime.TIME_24_WITH_SECONDS);
            RestAPIService.getAll(Serviceurls.FO_REPORTS_DEMOGRAPHICS + `?from_date=${this.state.fromDate}&to_date=${this.state.toDate}&patient_name=${this.state.patientName}&appointment_date=${appointmentDate}&gender=${genderSearch}&start_time=${setStartTime}&end_time=${setEndTime}&ref_type=${this.state.refferedType}&ref_detail=${this.state.refferalValue}`)
                .then((response) => {
                    if (response.data.status === "success") {
                        this.setState({
                            patientData: response.data.data?.map(item => ({
                                ...item,
                                address: `${item?.address_line_1 || "-"} | ${item?.address_line_2 || "-"}`
                            })),
                            FilteredFromDate: this.state.fromDate,
                            FilteredToDate: this.state.toDate,
                        },()=>{this.LoaderFunction(false)})
                    }
                }).catch((error) => {
                    this.LoaderFunction(false)
                    if (error?.response?.data?.status === 'fail') {
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.errorMessage(error.message)
                    }
                })
        } catch (error) {
            this.LoaderFunction(false)
            this.errorMessage(error.message)
        }
    }

    getStaffRefferalData = () => {
        try {
            RestAPIService.getAll(Serviceurls.FO_CONFIG_REF_Config)
                .then((response) => {
                    if (response.data.status === "success") {
                        this.setState({
                            refStaffData: response.data.data
                        })
                    }
                }).catch((error) => {
                    this.errorMessage(error.response.data.message || error.message)
                })
        } catch (error) {

            this.errorMessage(error.message)
        }
    }

    getReferralDoctorData = () => {
        try {
            this.LoaderFunction(true)
            RestAPIService.getAll(Serviceurls.FO_CONFIG_REF_DOCTOR)
                .then((response) => {
                    if (response.data.status === "success") {
                        this.setState({
                            refDoctorData: response.data.data
                        })
                    }
                }).catch((error) => {
                    this.errorMessage(error.response.data.message || error.message)
                })
        } catch (error) {

            this.errorMessage(error.message)
        }
    }

    getRefSourceData = () => {
        try {
            this.LoaderFunction(true)
            RestAPIService.getAll(Serviceurls.FO_CONFIG_REF_SOURCE)
                .then((response) => {
                    if (response.data.status === "success") {
                        this.setState({
                            refSourceData: response.data.data
                        })
                    }
                }).catch((error) => {
                    this.errorMessage(error.response.data.message || error.message)
                })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    printReports = () => {
        try {
            let appointmentDate = this.state.appointmentDate === null ? "" : this.state.appointmentDate
            let genderSearch = [];
            this.state.gender.forEach(element => { genderSearch.push(element.value) });
            var {FilterDatas} = this.state
            let start_time = FilterDatas.startTime ? new Date(FilterDatas.startTime) : ''
            let end_time = FilterDatas.endTime ? new Date(FilterDatas.endTime) : ''
            let setStartTime = start_time === '' ? '' : DateTime.fromJSDate(start_time).toLocaleString(DateTime.TIME_24_WITH_SECONDS);
            let setEndTime = end_time === '' ? '' : DateTime.fromJSDate(end_time).toLocaleString(DateTime.TIME_24_WITH_SECONDS);
            RestAPIService.getAll(Serviceurls.FO_REPORTS_DEMOGRAPHICS + `?from_date=${this.state.fromDate}&to_date=${this.state.toDate}&patient_name=${this.state.patientName}&appointment_date=${appointmentDate}&gender=${genderSearch}&export_type=pdf&start_time=${setStartTime}&end_time=${setEndTime}&ref_type=${this.state.refferedType}&ref_detail=${this.state.refferalValue}`)
                .then((response) => {
                    const file = new Blob(
                        [response.data],
                        { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                }).catch((error) => {
                    this.errorMessage(error.message)
                })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }
    selectedTime = (start, end,error) => {
        this.state.FilterDatas.startTime = start
        this.state.FilterDatas.endTime = end
        this.setState({ FilterDatas: this.state.FilterDatas, timeError: error })
    }

    renderFilterScreen = () => {
        const { t } = this.props
        const getLabel = () => {
            switch (this.state.refferedType) {
                case "Source": return "Referred Source";
                case "Doctor": return "Doctor";
                case "Staff": return "Referred Staff";
                default: return "Referral Detail";
            }
        };

        const getMenuItems = () => {
            switch (this.state.refferedType) {
                case "Doctor":
                    return this.state.refDoctorData?.map((item, idx) => (
                        <MenuItem key={idx} value={item.name}>{item.name}</MenuItem>
                    ));
                case "Source":
                    return this.state.refSourceData?.map((item, idx) => (
                        <MenuItem key={idx} value={item.source_name}>{item.source_name}</MenuItem>
                    ));
                case "Staff":
                    return this.state.refStaffData?.map((item, idx) => (
                        <MenuItem key={idx} value={item.id}>{item.name}</MenuItem>
                    ));
                default:
                    return null;
            }
        };
        return (
            <Box component={"div"} className='eMed_rts_filter_container'>
                <Box component={"div"} className='eMed_filter_Top'>
                    <Typography variant='h6' fontWeight={600}>{t("Filter")}</Typography>
                    <Button onClick={() => { this.setState({ FilterOpen: false }) }} className='eMed_usrconf_btn'>
                        <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
                    </Button>
                </Box>
                <Box className='eMed_rts_middle'>
                    <Box className='eMed_date_filter'>
                        <CommonDatePicker
                            FromDate={this.state.fromDate}
                            ToDate={this.state.toDate}
                            DateIndex={this.state.dateIndex}
                            SelectedDates={this.FilterDate.bind(this)} 
                            HideAllMenu={true}/>
                    </Box>
                    <Box sx={{width: '22vw'}}>
                    <CommonTimeRangePicker
                        startTime={this.state.FilterDatas?.startTime}
                        endTime={this.state.FilterDatas?.endTime}
                        selectedTime={this.selectedTime.bind(this)}
                        FromDate={this.state.fromDate}
                        ToDate={this.state.toDate}
                        onError={this.state.FilterDatas.onError}
                    />
                    </Box>
                    <Box className='eMed_rts_dropdown'>
                        <TextField
                            size='small'
                            fullWidth
                            label="Patient Name"
                            value={this.state.patientName}
                            name="patientName"
                            onChange={(e) => { this.onChangeHandler(e) }}
                        />
                    </Box>
                    <Box className='eMed_rts_dropdown'>
                        <LocalizationProvider dateAdapter={AdapterDayjs} >
                            <DatePicker
                                inputFormat='DD-MM-YYYY'
                                label={t('SelectAppointmentDate')}
                                value={this.state.appointmentDate}
                                name="appointmentDate"
                                onChange={(newDate) => { 
                                    if (newDate == null) {
                                        this.setState({
                                            appointmentDate: null
                                        });
                                    } else {
                                        this.setState({
                                            appointmentDate: DateTime.fromJSDate(newDate?.$d).toFormat('yyyy-MM-dd')
                                        });
                                    }
                                 }}
                                renderInput={(params) => <TextField style={{ width: '20vw' }} size='small' {...params} />}
                            />
                        </LocalizationProvider>
                    </Box>
                    <Box className='eMed_rts_dropdown'>
                        <Autocomplete
                            multiple
                            limitTags={1}
                            size='small'
                            options={genderList?.map((item) => item)}
                            getOptionLabel={(option) => (option?.label)}
                            value={this.state.gender}
                            onChange={(event, newValue) => {
                                this.setState({ gender: newValue })
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={t("selectGender")}
                                />
                            )}
                        />
                    </Box>
                    <FormControl size='small' sx={{ width: '20vw', ml: "1vw" }}>
                        <InputLabel id="referredby-select-label">{"Referred Type"}</InputLabel>
                        <Select
                            labelId="referredby-select-label"
                            MenuProps={{ style: { maxHeight: 250 } }}
                            size='small'
                            value={this.state.refferedType}
                            label={"Referred Type"}
                            onChange={(e) => {
                                this.setState({
                                    refferedType: e.target.value,
                                    refferalValue: '',
                                }
                                )
                            }}
                        >
                            <MenuItem value={""}>{"Select Type"}</MenuItem>
                            {this.state.refTypeData?.map((item) => (
                                <MenuItem value={item}>{item}</MenuItem>
                            ))}

                        </Select>
                    </FormControl>

                    <FormControl size='small' sx={{ width: '20vw', margin: "1vw 0vw 0.5vw 1vw" }}>
                        <InputLabel id="referredby-select-label">{getLabel()}</InputLabel>
                        <Select
                            labelId="referredby-select-label"
                            MenuProps={{ style: { maxHeight: 250 } }}
                            size='small'
                            disabled={!this.state.refferedType}
                            value={this.state.refferalValue}
                            label={getLabel()}
                            onChange={(e) => {
                                this.setState({
                                    refferalValue: e.target.value,
                                })
                            }}
                        >
                       <MenuItem value={""}>{this.state.refferedType === "Doctor" ? "Select Doctor" : this.state.refferedType === "Source" ? "Select Source" : this.state.refferedType === "Staff" ? "Select Staff" : ""}</MenuItem>
                            {getMenuItems()}
                        </Select>
                    </FormControl>
                </Box>
                <Stack spacing={2} direction="row" alignItems="center" justifyContent="center">
                    <Button variant='outlined' size="small"
                        onClick={() => {
                            this.setState({
                                patientName: "", appointmentDate: null,
                                gender: [],
                                fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                                toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                                dateIndex: 1,
                                FilterDatas: {
                                    "startTime":null,
                                    "endTime":null,
                                    "onError": false
                                },
                                timeError: false,
                                refferalValue: "",
                                refferedType: "",
                            }, () => this.getPatientData())
                        }}
                        id="eMed_Config_btn">{t("Clear")}</Button>
                    <Button variant='contained' size="small"
                    disabled={this.state.FilterDatas.startTime ? (this.state.FilterDatas.startTime && this.state.FilterDatas.endTime && this.state.timeError != true) ? false : true : false}
                        onClick={() => {
                            this.getPatientData()
                            this.setState({
                                FilterOpen: false
                            })
                        }}
                        id="eMed_Config_btn">{t("Search")}</Button>
                </Stack>
            </Box>
        )
    }

    msgClose() {
        this.setState({
            isErrorMsg: false,
            isErrorMsgText: '',
        })
    }
    gridToolBar = () => {
        let start_time = this.state.FilterDatas.startTime ? new Date(this.state.FilterDatas.startTime) : ''
        let end_time = this.state.FilterDatas.endTime ? new Date(this.state.FilterDatas.endTime) : ''
        let setStartTime = start_time === '' ? '' : DateTime.fromJSDate(start_time).toLocaleString(DateTime.TIME_24_WITH_SECONDS);
        let setEndTime = end_time === '' ? '' : DateTime.fromJSDate(end_time).toLocaleString(DateTime.TIME_24_WITH_SECONDS);
        let TextArray = [
            {label:"From Date", value: formatDate(this.state.FilteredFromDate)},
            {label:"To Date", value:formatDate(this.state.FilteredToDate)},
        ]
        if (this.state.FilterDatas.startTime !== null && this.state.FilterDatas.endTime !== null) {
            TextArray.push(
                { label: "Start Time", value: timeOnlyConvert(setStartTime) },
                { label: "End Time", value: timeOnlyConvert(setEndTime) }
            )
        }
        return(
          <Box>
             <CommonGridToolBarWithFilterText FilterTextArray={TextArray}/>
          </Box>
    
        )
      }
    render() {
        const { t } = this.props
        const columns = [
            {
                field: "patient_name", headerName: t("PatientName"), flex: 0.1,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.patient_name && params?.row?.patient_name?.length > 12 ?
                    <Tooltip placement='top' title={params?.row?.patient_name} arrow><div>{params?.row?.patient_name.slice(0, 10) + "..."}</div></Tooltip> : params?.row?.patient_name ? params?.row?.patient_name: "-"}</Box>)
            },
            {
                field: "patient_account_number", headerName: t("UHID"), flex: 0.1, align: "center", headerAlign: "center",
                renderCell: (params) => (<Box component={'div'}>{params?.row?.patient_account_number && params?.row?.patient_account_number?.length > 15 ?
                    <Tooltip placement='top' title={params?.row?.patient_account_number} arrow><div>{params?.row?.patient_account_number.slice(0, 13) + "..."}</div></Tooltip> : params?.row?.patient_account_number ? params?.row?.patient_account_number : "-"}</Box>)
            },
            {
                field: "patient_age", headerName: t("Age/Gender"), flex: 0.08, align: "center", headerAlign: "center",
                renderCell: (params) => {
                    let details = `${params?.row?.patient_age ? params?.row?.patient_age : "-"} / ${params?.row?.gender ? params?.row?.gender : "-"}`;
                    return(<Box component={'div'}>{details?.length > 15 ? <Tooltip placement='top' title={details} arrow><div>{details.slice(0, 13) + "..."}</div></Tooltip> : details ? details : "-"}</Box>)}
            },
            {
                field: "dob", headerName: t("DOB"), flex: 0.08, headerAlign: "center", align: "center",
                renderCell: (params) => (<Box component={'div'}>{params?.row?.dob ? formatDate(params?.row?.dob) : "-"}</Box>)
            },
            {
                field: "patient_mobile_number", headerName: t("MobileNumber"), flex: 0.1, headerAlign: "center", align: "center",
                renderCell: (params) => (<Box component={'div'}>{params?.row?.patient_mobile_number ? params?.row?.patient_mobile_number : "-"}</Box>)
            },
            {
                field: "register_date", headerName: t("AppointmentDate"), flex: 0.1, headerAlign: "center", align: "center",
                renderCell: (params) => (<Box component={'div'}>{params?.row?.register_date ? formatDate(params?.row?.register_date) : "-"}</Box>)
            },
            {
                field: "marital_status", headerName: t("MaritalStatus"), flex: 0.08, headerAlign: "center", align: "center",
                renderCell: (params) => (<Box component={'div'}>{params?.row?.marital_status?.length > 10 ?
                    <Tooltip placement='top' title={params?.row?.marital_status} arrow><div>{params?.row?.marital_status.slice(0, 10) + "..."}</div></Tooltip>
                    : params?.row?.marital_status ? params?.row?.marital_status : "-"}</Box>)
            },
            {
                field: "email", headerName: t("Emailid"), flex: 0.09, headerAlign: "center", align: "center",
                renderCell: (params) => (<Box component={'div'}>{params?.row?.email?.length > 10 ?
                    <Tooltip placement='top' title={params?.row?.email} arrow><div>{params?.row?.email.slice(0, 10) + "..."}</div></Tooltip>
                    : params?.row?.email ? params?.row?.email : "-"}</Box>)
            },
            {
                field: "address", headerName: t("Address"), flex: 0.1, headerAlign: "center", align: "center",
                renderCell: (params) => {
                    return (<Box component={'div'}>{params?.row?.address?.length > 10 ?
                        <Tooltip placement='top' title={params?.row?.address} arrow><div>{params?.row?.address?.slice(0, 10) + "..."}</div></Tooltip>
                        : params?.row?.address || "-"}</Box>)
                }
            },
            {
                field: "occupation", headerName: t("Occupation"), flex: 0.09, headerAlign: "center", align: "center",
                renderCell: (params) => (<Box component={'div'}>{params?.row?.occupation?.length > 10 ?
                    <Tooltip placement='top' title={params?.row?.occupation} arrow><div>{params?.row?.occupation.slice(0, 10) + "..."}</div></Tooltip>
                    : params?.row?.occupation ? params?.row?.occupation : "-"}</Box>)
            },
            {
                field: "ref_type", headerName: t("Reffered Type"), flex: 0.09,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.ref_type?.length > 10 ?
                    <Tooltip placement='top' title={params?.row?.ref_type} arrow>
                        <div>{params?.row?.ref_type.slice(0, 10) + "..."}</div>
                    </Tooltip> : params?.row?.ref_type || "-"}</Box>)
            },
            {
                field: "ref_detail", headerName: t("Refferal Details"), flex: 0.09,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.ref_detail?.length > 10 ?
                    <Tooltip placement='top' title={params?.row?.ref_detail} arrow>
                        <div>{params?.row?.ref_detail.slice(0, 10) + "..."}</div>
                    </Tooltip> : params?.row?.ref_detail || "-"}</Box>)
            },
            {
                field: "referral_description", headerName: t("Refferal Desc"), flex: 0.09,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.referral_description?.length > 10 ?
                    <Tooltip placement='top' title={params?.row?.referral_description} arrow>
                        <div>{params?.row?.referral_description.slice(0, 9) + "..."}</div>
                    </Tooltip> : params?.row?.referral_description || "-"}</Box>)
            },
        ]
        return (
            <Box component={'div'} className='eMed_rts_container'>
                <Box component={"div"} className='eMed_Top_Container'>
                    <Box component={"div"} className='eMed_Cards_Container'></Box>
                    <Box component={"div"} className='eMed_Action_Container'>
                        <Box component={"div"} className='eMed_Filter_Icon_div'>
                            <Button className='eMed_usrconf_btn' onClick={() => { this.setState({ FilterOpen: true }) }}>
                                <img src={ImagePaths.Filter.default} alt="filter" className='eMed_action_img' />
                            </Button>
                        </Box>
                        <Button className='eMed_usrconf_btn' onClick={() => { this.printReports() }}>
                            <img src={ImagePaths.LabPrintIcon.default} alt="print" className='eMed_action_img' />
                        </Button>
                        {/* <Button className='eMed_usrconf_btn'>
                            <img src={ImagePaths.LabUploadButton.default} alt="upload" className='eMed_action_img' />
                        </Button> */}
                    </Box>
                </Box>
                <Box component={'div'} className='eMed_rts_table'>
                    <DataGrid
                        rows={this.state.patientData}
                        columns={columns}
                        getRowId={(row) => row.patient_id}
                        page={this.state.page}
                        pageSize={this.state.pageSize}
                        localeText={{
                            toolbarColumns: "",
                            toolbarDensity: "",
                            toolbarExport: "",
                            toolbarFilters: "",
                            toolbarExportPrint: ""
                        }}
                        components={{
                            Toolbar: this.gridToolBar,
                            NoRowsOverlay: () => (
                                <Stack className='eMed_conf_nodata'>
                                    {t("NoRecordsFound")}
                                </Stack>
                            )
                        }}
                        onPageChange={(newPage) => { this.setState({ page: newPage }) }}
                        onPageSizeChange={(newPageSize) => this.setState({ pageSize: newPageSize })}
                        rowsPerPageOptions={[10, 20, 30]}
                        pagination
                        headerHeight={40}
                        disableSelectionOnClick
                        loading={this.state.isLoader}
                    />
                </Box>
                <Drawer
                    anchor={'right'}
                    open={this.state.FilterOpen}
                    ModalProps={{ onBackdropClick: this.closeFilter }}
                >
                    {this.renderFilterScreen()}
                </Drawer>
                {this.state.isErrorMsg ?
                    <ToastMsg
                        severity={'error'}
                        msg={this.state.isErrorMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
            </Box>
        )
    }
    closeFilter = () => {
        this.setState({ FilterOpen: false })
    }
}


export default withTranslation()(DemographicsReport)